function parseMoney(value) {
    if (value === null || value === undefined || value === '')
        return null;
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0)
        return null;
    return Math.round(parsed * 100) / 100;
}
function isEnabledFlag(value) {
    if (value === true || value === 1)
        return true;
    if (value === false || value === 0 || value == null || value === '') {
        return false;
    }
    const normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
}
/** True when the package is configured to charge one service fee for the whole package. */
export function hasPackageFlatServiceFee(eventPackage) {
    return isEnabledFlag(eventPackage?.useFlatServiceFee ?? eventPackage?.use_flat_service_fee);
}
/**
 * Flat package service fee override.
 * Returns the dollar amount when enabled (including 0), otherwise null (use org per-seat rules).
 */
export function getPackageFlatServiceFee(eventPackage) {
    if (!hasPackageFlatServiceFee(eventPackage))
        return null;
    const amount = parseMoney(eventPackage?.flatServiceFee ?? eventPackage?.flat_service_fee);
    return amount === null ? 0 : amount;
}
/** Website package carts that snapshotted org-config or package-flat fees. */
export function isTrustedWebsitePackageFeeSnapshot(snapshot) {
    return (snapshot?.source === 'org-config' || snapshot?.source === 'package-flat');
}
